import React, { useRef } from 'react';

function ImageCapture({ 
  capturedImage, 
  setCapturedImage, 
  onProceed 
}) {
  const fileInputRef = useRef(null);

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        setCapturedImage(event.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-xl p-8">
      <h1 className="text-4xl font-extrabold text-gray-900 mb-10 text-center">
        Face Shape Analysis
      </h1>
      <div className="mb-8">
        <h2 className="text-2xl font-black text-gray-900 text-center">⚠️Selfie Guide⚠️</h2>
        <div className="p-4 space-y-3">
          <div className="flex items-start gap-3">
            <span className="text-blue-600 font-bold text-xl">1.</span>
            <p className="text-gray-900 text-xl leading-snug">Make sure your face is completely <span className="text-blue-600 font-bold">STRAIGHT</span>, with no tilting or weird angles</p>
          </div>
          <div className="flex items-start gap-3">
            <span className="text-blue-600 font-bold text-xl">2.</span>
            <p className="text-gray-900 text-xl leading-snug">Pull your hair back if needed so your <span className="text-blue-600 font-bold">FOREHEAD IS FULLY VISIBLE</span></p>
          </div>
          <div className="flex items-start gap-3">
            <span className="text-blue-600 font-bold text-xl">3.</span>
            <p className="text-gray-900 text-xl leading-snug">Keep camera as <span className="text-blue-600 font-bold">FAR AWAY</span> from your face as comfortable</p>
          </div>
          <div className="flex items-start gap-3">
            <span className="text-blue-600 font-bold text-xl">4.</span>
            <p className="text-gray-900 text-xl leading-snug">Keep a completely <span className="text-blue-600 font-bold">NEUTRAL EXPRESSION</span></p>
          </div>
        </div>
      </div>

      <div className="mb-8 grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-green-50 border-2 border-green-200 rounded-lg p-4 text-center">
          <p className="text-green-700 font-black text-xl mb-3">✅ GOOD EXAMPLE</p>
          <img
            src="/good_example.png"
            alt="Good selfie example"
            className="w-full rounded-lg object-cover"
          />
        </div>
        <div className="bg-red-50 border-2 border-red-200 rounded-lg p-4 text-center">
          <p className="text-red-700 font-black text-xl mb-3">❌ BAD EXAMPLE</p>
          <img
            src="/bad_example.png"
            alt="Bad selfie example"
            className="w-full rounded-lg object-cover"
          />
        </div>
      </div>
      
      {!capturedImage ? (
        <div className="space-y-6">
          <div className="flex flex-col gap-4">
            <button
              onClick={() => fileInputRef.current?.click()}
              className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-lg transition duration-200 shadow-md"
            >
              📸 Select Photo
            </button>
            <input
              ref={fileInputRef}
              type="file"
              accept="image/*"
              onChange={handleFileUpload}
              className="hidden"
            />
          </div>
        </div>
      ) : (
        <div className="space-y-6">
          <img
            src={capturedImage}
            alt="Captured"
            className="w-full rounded-lg shadow-lg"
          />
          <div className="flex gap-4">
            <button
              onClick={() => setCapturedImage(null)}
              className="flex-1 bg-gray-500 hover:bg-gray-600 text-white font-semibold py-3 px-6 rounded-lg transition duration-200"
            >
              ↻ Retake
            </button>
            <button
              onClick={onProceed}
              className="flex-1 bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-lg transition duration-200 shadow-md"
            >
              Continue →
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default ImageCapture;
